/**
 * @generated SignedSource<<f02fea43d6627295e10af48cf74486df>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment$data = {
  readonly sumGrossPriceWithDiscounts: any;
  readonly sumGrossPriceWithoutDiscounts: any;
  readonly " $fragmentType": "DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment";
};
export type DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment$key = {
  readonly " $data"?: DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DiscountUsagePriceDisplay_SearchDiscountUsageResultFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sumGrossPriceWithDiscounts",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sumGrossPriceWithoutDiscounts",
      "storageKey": null
    }
  ],
  "type": "SearchDiscountCodeUsagesResult",
  "abstractKey": null
};

(node as any).hash = "fdeec8c48a256f557a5b2906e134d40e";

export default node;
